import { Button, Card, CardContent, Typography } from "@mui/joy";

const NoCandidates = ({ handleBackToCandidates }: { handleBackToCandidates: () => void }) => {
  return (
    <Card sx={{ mt: 8, p: 10, textAlign: "center" }}>
      <CardContent>
        <Typography level="h4" sx={{ mb: 2 }}>
          No people selected
        </Typography>
        <Typography level="body-md" sx={{ color: '#666', mb: 3 }}>
          You haven't selected any people yet. Go back and add some!
        </Typography>
        <Button
          variant="outlined"
          onClick={handleBackToCandidates}
          sx={{ borderColor: '#2e2d7e', color: '#2e2d7e', '&:hover': { borderColor: '#23225f', backgroundColor: 'rgba(46, 45, 126, 0.1)' } }}
        >
          Back to People
        </Button>
      </CardContent>
    </Card>
  );
}

export default NoCandidates;